import type { IntlShape } from "react-intl";

export const getTableLabels = (intl: IntlShape) => ({
  agendamento: intl.formatMessage({ id: "intl-msg:monitoring.table.scheduling" }),
  veiculo: intl.formatMessage({ id: "intl-msg:monitoring.table.vehicle" }),
  chassi: intl.formatMessage({ id: "intl-msg:monitoring.table.chassis" }),
  odometro: intl.formatMessage({ id: "intl-msg:monitoring.table.odometer" }),
  horimetro: intl.formatMessage({ id: "intl-msg:monitoring.table.hourmeter" }),
  licensePlate: intl.formatMessage({ id: "intl-msg:monitoring.table.licensePlate" }),
  accountName: intl.formatMessage({ id: "intl-msg:monitoring.table.account" }),
  acoes: intl.formatMessage({ id: "intl-msg:monitoring.table.fieldCampaigns" }),
  revisoes: intl.formatMessage({ id: "intl-msg:monitoring.table.periodicReviews" }),
  score: intl.formatMessage({ id: "intl-msg:monitoring.table.score" }),
  grupoManutencao: intl.formatMessage({ id: "intl-msg:monitoring.table.maintenanceGroup" }),
  statusGarantia: intl.formatMessage({ id: "intl-msg:monitoring.table.warrantyStatus" }),
  status: intl.formatMessage({ id: "intl-msg:monitoring.table.status" }),
  rio: intl.formatMessage({ id: "intl-msg:monitoring.table.rio" }),
  volksTotal: intl.formatMessage({ id: "intl-msg:monitoring.table.volksTotal" }),
  ultimaRevisao: intl.formatMessage({ id: "intl-msg:monitoring.table.lastReview" }),
  proximaRevisao: intl.formatMessage({ id: "intl-msg:monitoring.table.nextReview" }),
});
